/*
 * ## ⭐⭐ 판 E — 정본 `SpaceDetailPage` 에서 ★ ⭐ «가져올 것이 0» 이다 (2026-10-10 실측)
 *
 * 같은 라우트(`project/space/:teamId`)를 ★ 이 파일이 ⭐ 이미 그린다. 정본과 맞대니:
 *
 *   잰 법 ⇒ git diff --numstat dd05a6fcd:…/ProjectPage/SpaceDetailPage.tsx
 *                             d4b2ff7f2:…/ProjectV2/SpaceV2Page.tsx
 *          ⇒ ⚠ ⭐ 해시를 «못 박았다» — ★ origin/main 은 ⭐ 움직이는 ref 라
 *             ⇒ ⇒ ★ 그 이름으로 적으면 ⭐ 이 명령이 «아래 수를 못 만든다».
 *          ⇒ ★ ＋113 −18  ⇐ ⚠ ⭐ «바탕 d4b2ff7f2» 를 못 박는다 — ⇒ ★ 이 쪽지가 ⭐ 그 수를 바꾼다
 *             ⇒ ⇒ (지금 996851264 로 재면 ★ ＋148 −18 이다 — ⇒ ⭐ 늘어난 35 가 ★ 이 머리말이다)
 *             ⇒ ⇒ ⭐ 「정본에만」이 ★ 18 줄 · 우리가 ★ 113 줄을 더 썼다
 *   크기  ⇒ ⭐ «코드 줄»(주석·빈 줄을 뺀 수) ⇒ 정본 ★ 289 ⇔ 우리 ★ 290 ⇒ ⇒ ⭐ 거의 «같다»
 *          ⇒ 날 줄(wc -l)                  ⇒ 정본 ★ 331 ⇔ 우리 ★ 426 (⇐ 바탕 d4b2ff7f2)
 *          ⇒ ⇒ ⛔ 종전 줄의 「우리가 더 크다」는 ★ «날 줄»의 이야기였다 —
 *             ⇒ ⇒ ⭐ 그 차이 95 줄은 ★ 거의 다 «우리 머리말»이다(⇒ 코드로는 ＋1).
 *          ⇒ ⚠ ⭐ 코드 줄은 ★ 이 쪽지가 ⛔ 안 바꾼다(290 ⇒ 290 실측) ⇒ ⇒ 그래서 ★ 그쪽을 먼저 적는다.
 *   CSS   ⇒ SpaceDetailPage.css ⇔ SpaceV2Page.css ⇒ ★ ⭐ «글자까지 같다»
 *          ⇒ ⇒ 7,793 자 · wc -l ★ 251 줄 · 코드 줄 ★ 213
 *   api   ⇒ ★ ⭐ 똑같다 — listTeams · listProjects · listTeamMembers
 *          ⇒ ⇒ ⭐ 즉 ★ 서버 일 ⭐ 0 · 새 API ⭐ 0 · 마이그 ⭐ 0
 *
 *   ⚠ 2026-10-10 정정 — ★ 위 수를 ⭐ 고쳤다. 틀린 까닭이 ★ 둘이다:
 *     ① ★ 줄 수를 split 으로 세어 ⇒ ⭐ 늘 ＋1 이었다(끝 줄바꿈 뒤 빈 칸) ⇒ ★ wc -l 로 바꿨다
 *     ② ⭐⭐ «우리 쪽» 수는 ★ 이 쪽지가 ⇒ ⭐ «스스로» 키웠다 ⇒ ⇒ ★ 잰 ref 를 못 박고
 *        ⇒ ⇒ ⭐ «코드 줄»(주석 뺀 수)을 함께 적는다 — ★ 그것은 ⭐ 안 썩는다.
 *
 * ⇒ ⭐ 그 ★ 18 줄(공백·닫는 괄호는 빼고 셌다)의 정체는 ⇒ ★ ⭐ 셋뿐이다:
 *     ① import 5 ＋ ProjectNavShell 3 ⇒ ★ 정본은 ⭐ «파일 안»에서 네비를 감싼다
 *        ⇒ ⇒ ★ 우리는 ⭐ «라우터»에서 감싼다 — ⇒ 아래 import 머리말이 그 까닭을 적고
 *           ⇒ ⇒ ★ space-v2.guard.test.tsx ④ 가 ⭐ 「네비는 한 겹」을 ★ 이미 잠근다
 *        ⇒ ⇒ ⇒ ⛔ 가져오면 ★ 네비가 ⭐ 두 겹으로 그려진다
 *     ② spaceColor ＋ projectColor 5 ⇒ ⛔ 그 SPACE_COLORS 표는 ★ ⭐ 맨 hex ★ 여덟이다
 *        ⇒ ⇒ ★ 우리는 ⭐ team?.color ?? stripColor(teamId) — ⇒ ★ «사용자가 고른 색»이 먼저다
 *        ⇒ ⇒ ⇒ ⛔ 가져오면 ★ CLAUDE.md 「인라인 hex 금지」가 ⭐ 되돌아가고,
 *           ⇒ ⇒ ★ space-v2.guard.test.tsx ⑦-ⓐ(⭐ stripColor 가 유일한 해시 색원)가 빨개진다
 *     ③ 주석 2 ＋ 선언 한 줄(`export function SpaceDetailPage()`)
 *
 * ⚠ 「우리 것이 더 낫다」는 ⛔ 내 판단이 아니다 — ★ 위 수가 말하는 것이다.
 *   ⇒ ⛔ 그리고 ★ 「빼는 것」은 ⭐ 사용자가 정한다 — ⇒ 나는 ★ 「가져올 것이 0」만 적는다.
 *
 * ⏳ **만료 조건 — ★ «내놓는 이름»으로 적는다**
 *   지금 내놓는 이름 ⇒ 정본 `SpaceDetailPage` · `spaceColor`
 *                   ⇒ 우리 `SpaceV2Page` · `SPACE_V2_DYNAMIC_KEYS` (색은 `stripColor` 가 한다)
 *   ⇒ ⭐ 정본이 ★ 저 둘 ⭐ «말고» ★ 새 이름을 내놓는 날 ⇒ ⇒ ★ 이 판정을 ⭐ 다시 재라.
 *   ⇒ ⚠ ⛔ 「그 파일이 있다/없다」로 재지 ★ 말 것 — ⇒ ⭐ 남이 같은 «파일 이름»을
 *      ⇒ ⇒ ★ ⭐ «일부만» 만들 수 있다(⇒ 상태가 ★ 없다/일부/전부 ⭐ 셋이다).
 *      ⇒ ⇒ ⇒ ★ 가르는 것은 ⭐ 「그 export 가 ★ 하는 일을 ⇒ 우리 쪽 ⭐ 어느 이름도 ⛔ 안 하나」다.
 */
import { useCallback, useEffect, useMemo, useState, useSyncExternalStore } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Settings, Link as LinkIcon, MoreHorizontal, Info, Plus, ArrowLeft } from '../../icons';
import { listProjects, type TaskProjectDto } from '../../api/tasks';
import { listTeams, listTeamMembers, type TeamDto, type TeamMemberDto } from '../../api/project-teams';
import { Avatar } from '../../components/shared';
import { FavoriteStar } from '../../components/Favorites';
import { useAuthStore } from '../../store/authStore';
import { ProjectCreateSimpleModal } from '../ProjectPage/ProjectCreateSimpleModal';
import { SpaceInfoHoverCard } from './SpaceInfoHoverCard';
/*
 * ⛔ 정본의 `import { ProjectNavShell } from './ProjectNavShell'` 를 ★ 뺐다.
 *   까닭: main 은 네비를 ⭐ «라우터»에서 감싼다(router/index.tsx 의 `project/…` 전부).
 *   ⇒ 정본처럼 «페이지 안»에서 또 감싸면 ⇒ ⛔ 네비가 ★ 두 겹으로 그려진다.
 *   ⇒ 1차에서 이 라우트를 이미 ProjectNavShell 로 감쌌으므로 ★ 라우터 쪽으로 한결같게 둔다.
 */
/*
 * ⛔ 정본의 `projectColor` 를 ★ 베끼지 «않았다». 그 함수는 main 에 ⭐ 없지만(레포 전체 0건),
 *   ★ 그 «규칙»은 main 이 이미 적어 두었다 — api/tasks.ts:37-38:
 *     「color 는 null 일 수 있다 — 그때는 종전처럼 id 해시 색(stripColor)으로 그린다」
 *   ⇒ ⭐ 그래서 main 의 `stripColor` 를 쓰고 폴백만 아래 projectAccent 에 둔다.
 *   ⇒ ⛔ 색표(STRIP_COLORS)를 ★ 두 벌로 만들지 않는다 — 그 함정은 적혀 있다.
 */
import { stripColor } from '../TaskPage/ProjectTopBar';
import { tProject, getProjectLang, subscribeProjectLang } from '../../lib/project-i18n';
import '../ProjectPage/ProjectPage.css';
import './SpaceV2Page.css';

type SortKey = 'name' | 'progress' | 'due';

/**
 * 역할 코드 → 화면 표기. 서버가 주는 ProjectRole 그대로 매핑한다.
 *
 * ⚠⚠ 이 표의 열쇠는 ★ `tProject('…')` 리터럴이 ⭐ «아니다» — 아래에서 `ROLE_LABEL[p.myRole]` 로
 *   ★ «동적»으로 부른다. ⇒ ⛔ 그래서 소스를 `tProject\('([^']+)'` 로 훑는 도구는
 *   ★ 이 셋(manager · member · viewer)을 ⭐ «못 센다». 2026-10-08 에 내가 실제로 놓쳤다.
 *   ⇒ ⭐ 아래 `SPACE_V2_DYNAMIC_KEYS` 가 그것을 ★ 코드로 드러낸다(가드가 그 배열을 센다).
 */
const ROLE_LABEL: Record<string, string> = {
  OWNER: 'project.space.role_owner',
  MANAGER: 'project.space.role_manager',
  MEMBER: 'project.space.role_member',
  VIEWER: 'project.space.role_viewer',
};

/**
 * ⭐ 「훑기로는 안 보이는 열쇠」를 ★ «내보내서» 보이게 한다.
 * ⇒ 가드가 이 배열을 돌며 ★ project-i18n 에 그 열쇠가 있나 잰다 ⇒ ⛔ 손으로 적은 목록이 아니다.
 */
export const SPACE_V2_DYNAMIC_KEYS = Object.values(ROLE_LABEL);

/**
 * SpaceDetailPage (2026-08-19, 시안 "Axi Works – 내 프로젝트 목록(제안)")
 *
 * 스페이스(=작업그룹/팀) 하나를 열었을 때의 화면. 왼쪽은 그 스페이스의 **프로젝트 목록 표**,
 * 오른쪽은 **스페이스 정보** 패널이다.
 *
 * 시안과 다르게 간 곳(있지도 않은 것을 그리지 않으려고):
 *   - [폴더 생성] — 프로젝트를 담는 폴더 개념이 아직 없다. 버튼만 만들면 눌러도 아무 일이
 *     없는 자리가 되므로 넣지 않았다.
 *   - '진행 상태' 컬럼 — 프로젝트에 상태 필드가 없다. 시안도 전부 "설정 안 함" 이라
 *     같은 표기를 쓰되, 태스크 집계로 진행/완료는 구분해 보여 준다.
 *   - '시작일' — 프로젝트에 시작일 필드가 없어 '-' 로 둔다(추정해서 채우지 않는다).
 *   - 오른쪽 도넛은 시안의 단색(설정 안 함) 대신 **진행 중 / 완료** 비율을 그린다 —
 *     이 화면에서 실제로 읽을 값이 그것뿐이라서.
 *
 * ──────────────────────────────────────────────────────────────────────────────
 * ## ⭐ 2026-10-08 — main 으로 옮기며 ★ 바꾼 것 (2차 2-1′ · 깃발 `PROJECT_V2` 뒤)
 *
 * ⛔ 이 파일은 ★ 깃발이 ⭐ «꺼진» 동안 안 돈다 — 라우터가 `ProjectV2Route` 를 거친다.
 *   ⇒ 그래서 아래 「모르는 칸」이 ★ 사용자에게 보이지 않는다. 켜기 «전»에 서버가 와야 한다.
 *
 * ### ✅ 2026-10-08 (저녁) — ⭐ 서버 칸 둘이 와서 ★ «잠가 둔 세 자리»를 열었다
 *
 * 아침에는 서버가 `myRole`·`color` 를 안 줘서 ★ 세 자리를 잠가 두었다. ⇒ ⭐ 그날
 * 백엔드가 둘을 세웠고(#2289), ⇒ ★ 프론트 DTO 에 칸을 더해(`api/tasks.ts`·`api/project-teams.ts`)
 * ⇒ ⇒ ⭐ 아래처럼 ★ «정본 꼴»로 돌렸다:
 * ```
 * ⓐ 「내 권한」 칸   세 상태(모름/미참여/역할) ⇒ ⭐ 정본의 ★ «두 상태»로
 *    ⇒ ⚠ 그러면 「모름」은 어디로? ⇒ ⭐ 타입은 `?:` 라 여전히 undefined 가 «될 수 있다».
 *      ⇒ ⇒ ⭐ 그래서 ★ 「서버가 늘 보낸다」를 ⭐ «가드»가 잠근다 —
 *        space-v2.guard.test.tsx 의 ★ 「서버 serializeProject 의 칸이 DTO 에 다 있다」.
 *      ⇒ ⇒ ⇒ ⭐ 서버가 그 칸을 빼면 ⇒ ★ 화면이 거짓말하기 «전»에 그 가드가 빨개진다.
 *      ⇒ ⛔ 즉 ★ 「세째 상태」를 ⭐ «화면»에서 떼는 대신 ⇒ ★ «계약»에 두었다.
 * ⓑ 거르개 「내가 참여한 것만」  `disabled` 를 ★ 뗐다 ⇒ ⭐ 실제로 걸러진다
 *    ⇒ ★ 가드가 ⭐ «눌러서 줄어드는 것»까지 잰다(⛔ 「눌리기는 하는데 안 걸러지는」 판을 막는다)
 * ⓒ 스페이스 점 색   `spaceColor`(8색 표) ★ 지웠다 ⇒ ⭐ `team?.color ?? stripColor(teamId)`
 * ```
 *
 * ### ⭐⭐ ⓒ — 색을 ★ «맞춘» 까닭 (2026-10-08 사용자 결정 ③ 「맞춥니다」)
 *
 * ⭐⭐ 2026-10-11 정정 — ★ 아래 ⭐ 「84% 가 바뀐다」가 ⇒ ★ 사용자가 ⭐ «고른» 것이 됐다
 *   ⇒ ★ 사용자 ⇒ ⭐ 「정본 색을 그대로 보고 싶다」 ⇒ ⇒ 길 ★ ⓑ ⇒ ⭐ 색원 표를 ★ 정본 8색으로
 *   ⇒ ⇒ ★ 제가 다시 쟀다 ⇒ ⭐ 83.5% 가 바뀐다 (cuid 20,000 · 짧은 수 2,000 ⇒ 두 꼴 ★ 같다)
 *      ⇒ ⇒ ⛔ 그 수는 ★ 「하지 말 까닭」이 ⭐ 아니게 됐다 — ⇒ ★ 사용자가 ⭐ 보고 고른 변경이다
 *   ⇒ ⇒ ⇒ ✅ 그래서 ★ 이 화면은 ⇒ ⭐ 여전히 `stripColor` 하나를 부르고 ★ 색은 ⭐ 정본과 같다
 * ```
 * 잰 것
 *   main 의 /project/teams   ⇒ stripColor(t.id)  ★ 6색   (TeamsDetailPage.tsx)
 *   정본의 이 화면           ⇒ spaceColor(id)    ★ 8색
 *   ⭐ 그런데 ★ 정본 «자신»의 /project/teams 도 ⇒ ★ stripColor(6색) 이다  ⇐ ⭐ 결정적
 *     ⇒ ⇒ ⛔ 「정본이 8색」은 ★ 성립하지 않는다 — 정본에서도 ⭐ 1 : 9 로 6색이 다수다
 *   ⭐ 같은 id 가 두 표에서 «같은 색»이 되는 비율 = ★ 16.5% (id 1~2000 중 330)
 *     ⇒ ⇒ ⛔ 8색으로 모으면 ★ 옛 화면 팀 색의 ⭐ 84% 가 바뀐다(제품 9파일에 걸쳐)
 * ⇒ ✅ 그래서 ★ «이 화면»을 6색으로 맞췄다 — ⭐ 보이는 변경 ★ 0 이다
 *   (이 화면은 ★ 깃발 뒤라 ⭐ 아직 아무도 안 봤다 ⇒ ★ «공짜로 맞출 수 있는 유일한 때»였다)
 * ⇒ ⇒ ⭐ 그리고 ★ 「고른 색이 있으면 그것」은 ⭐ 그대로 산다 — `team?.color ??` 가 앞에 있다
 *   ⇒ ★ 그 규칙은 main 이 이미 적어 두었다(`api/tasks.ts` 의 `color` 칸 머리말과 같은 꼴)
 * ⇒ ⛔ `SPACE_COLORS` 표는 ★ «지웠다» — ⭐ 가드가 ★ 「레포에 그 표가 없다」를 잰다.
 *   ⇒ ⚠ 그 가드의 ★ «범위»를 글자로 적어 두었다: ⭐ 「팀/프로젝트를 칠하는 표」만이다.
 *     ⇒ ⛔ 캘린더·간트·워크스페이스의 색표는 ★ «다른 것»을 칠한다 ⇒ 건드리지 않는다.
 * ```
 */
export function SpaceV2Page() {
  useSyncExternalStore(subscribeProjectLang, getProjectLang, getProjectLang);
  const navigate = useNavigate();
  const { teamId = '' } = useParams<{ teamId: string }>();
  const authUser = useAuthStore((s) => s.user);
  const myId = authUser?.id != null ? String(authUser.id) : '';

  const [team, setTeam] = useState<TeamDto | null>(null);
  const [projects, setProjects] = useState<TaskProjectDto[]>([]);
  const [members, setMembers] = useState<TeamMemberDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [sort, setSort] = useState<SortKey>('name');
  const [onlyMine, setOnlyMine] = useState(false);
  const [creating, setCreating] = useState(false);
  const [infoOpen, setInfoOpen] = useState(true);
  // 정보(i) 버튼 hover/포커스 — 패널이 닫혀 있으면 요약 카드, 열려 있으면 이름 툴팁(2026-09-14).
  const [infoHover, setInfoHover] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [teams, ps] = await Promise.all([listTeams(), listProjects()]);
      setTeam(teams.find((t) => t.id === teamId) ?? null);
      setProjects(ps.filter((p) => p.teamId === teamId));
      setMembers(await listTeamMembers(teamId).catch(() => []));
    } catch (err) {
      setError((err as Error).message ?? tProject('project.space.err_fetch'));
    } finally {
      setLoading(false);
    }
  }, [teamId]);

  useEffect(() => { void load(); }, [load]);

  const rows = useMemo(() => {
    // ✅ 2026-10-08 (저녁) — ★ 정본 그대로다. 서버가 `myRole` 을 보내므로 ⇒ ⭐ 이 갈래가 «산다».
    const list = onlyMine ? projects.filter((p) => p.myRole != null) : projects;
    const sorted = [...list];
    sorted.sort((a, b) => {
      if (sort === 'progress') return pct(b) - pct(a);
      if (sort === 'due') {
        if (!a.dueDate && !b.dueDate) return 0;
        if (!a.dueDate) return 1;
        if (!b.dueDate) return -1;
        return a.dueDate < b.dueDate ? -1 : 1;
      }
      return a.name.localeCompare(b.name, 'ko');
    });
    return sorted;
  }, [projects, sort, onlyMine]);

  const donutDone = projects.filter((p) => (p.taskCount ?? 0) > 0 && (p.doneTaskCount ?? 0) >= (p.taskCount ?? 0)).length;
  const donutActive = projects.length - donutDone;
  const donutPct = projects.length > 0 ? Math.round((donutDone / projects.length) * 100) : 0;

  const owner = members.find((m) => m.role === 'LEADER') ?? members[0] ?? null;

  return (
    <div className="pj-detail-page spd-page">
      <button type="button" className="spd-back" onClick={() => navigate('/project')}>
        <ArrowLeft size={13} aria-hidden />
        {tProject('project.space.back')}
      </button>

      <header className="spd-head">
        <div className="spd-title">
          {/* ✅ 2026-10-08 (저녁) — ★ 「고른 색이 있으면 그것, 없으면 ⭐ 해시 색」.
              ⇒ ⭐ 해시 색은 ★ `stripColor` «하나»뿐이다 — 8색 표(spaceColor)는 ★ 지웠다(머리말 ⓒ).
              ⇒ ⚠ 그래서 ★ 같은 팀이 ⭐ `/project/teams` 와 ★ «같은 색»으로 보인다. */}
          <span className="spd-dot" style={{ background: team?.color ?? stripColor(teamId) }} aria-hidden />
          <h1>{team?.name ?? tProject('project.space.loading')}</h1>
          <button type="button" className="spd-ico" aria-label={tProject('project.space.settings')} data-tip={tProject('project.space.settings')} onClick={() => navigate(`/project/teams?team=${teamId}`)}>
            <Settings size={14} aria-hidden />
          </button>
          <button
            type="button"
            className="spd-ico"
            aria-label={tProject('project.space.copy_link')} data-tip={tProject('project.space.copy_link')}
            onClick={() => { void navigator.clipboard?.writeText(window.location.href); }}
          >
            <LinkIcon size={14} aria-hidden />
          </button>
          <button type="button" className="spd-ico" aria-label={tProject('project.space.more')} data-tip={tProject('project.space.more')} onClick={() => navigate(`/project/teams?team=${teamId}`)}>
            <MoreHorizontal size={14} aria-hidden />
          </button>
          {/* 즐겨찾기 — 홈 카드까지 되돌아가지 않고 여기서도 담고 뗄 수 있게(2026-08-21).
              이름은 아직 안 왔을 수 있어(로딩) 저장 라벨이 비지 않도록 폴백을 준다. */}
          <FavoriteStar
            to={`/project/space/${teamId}`}
            label={team?.name ?? tProject('project.space.loading')}
            size={14}
            className="spd-fav"
          />
        </div>

        <div className="spd-actions">
          <button type="button" className="spd-primary" onClick={() => setCreating(true)}>
            <Plus size={13} aria-hidden />
            {tProject('project.space.new_project')}
          </button>
          <button
            type="button"
            className={`spd-ico spd-ico--boxed${infoOpen ? ' spd-ico--on' : ''}`}
            aria-label={tProject('project.space.info')} data-tip={tProject('project.space.info')}
            aria-pressed={infoOpen}
            onClick={() => setInfoOpen((v) => !v)}
            onMouseEnter={() => setInfoHover(true)}
            onMouseLeave={() => setInfoHover(false)}
            onFocus={() => setInfoHover(true)}
            onBlur={() => setInfoHover(false)}
            onKeyDown={(e) => { if (e.key === 'Escape') setInfoHover(false); }}
            aria-describedby={infoHover ? 'spd-info-hover' : undefined}
          >
            <Info size={15} aria-hidden />
          </button>
          {infoHover && (
            <SpaceInfoHoverCard
              id="spd-info-hover"
              compact={infoOpen}
              team={team}
              members={members}
              projects={projects}
              myId={myId}
            />
          )}
        </div>
      </header>

      <div className={`spd-body${infoOpen ? '' : ' spd-body--wide'}`}>
        <section className="spd-main">
          <div className="spd-tools">
            <select
              className="spd-select"
              value={sort}
              onChange={(e) => setSort(e.target.value as SortKey)}
              aria-label={tProject('project.space.sort')}
            >
              <option value="name">{tProject('project.space.sort_name')}</option>
              <option value="progress">{tProject('project.space.sort_progress')}</option>
              <option value="due">{tProject('project.space.sort_due')}</option>
            </select>
            {/*
              ✅ 2026-10-08 (저녁) — ★ 잠금을 ⭐ «뗐다». 서버가 `myRole` 을 보내므로 ⇒ 실제로 걸러진다.
                ⇒ ⚠ 가드가 ★ 「⭐ 눌러서 «줄어드는 것»」까지 잰다 — ⛔ `disabled` 만 떼면
                  ⇒ ★ 「눌리기는 하는데 ⭐ 안 걸러지는」 판이 ★ 초록으로 지나간다.
            */}
            <button
              type="button"
              className={`spd-filter${onlyMine ? ' spd-filter--on' : ''}`}
              aria-pressed={onlyMine}
              onClick={() => setOnlyMine((v) => !v)}
            >
              {tProject('project.space.filter_mine')}
            </button>
          </div>

          {error && <div className="pj-error" role="alert">{error}</div>}

          <table className="spd-table">
            <thead>
              <tr>
                <th className="spd-th-name">{tProject('project.space.col_name')}</th>
                <th>{tProject('project.space.col_role')}</th>
                <th>{tProject('project.space.col_progress')}</th>
                <th>{tProject('project.space.col_start')}</th>
                <th>{tProject('project.space.col_due')}</th>
                <th>{tProject('project.space.col_status')}</th>
              </tr>
            </thead>
            <tbody>
              {!loading && rows.length === 0 && (
                <tr><td colSpan={6} className="spd-empty">{tProject('project.space.empty')}</td></tr>
              )}
              {rows.map((p) => {
                const done = (p.taskCount ?? 0) > 0 && (p.doneTaskCount ?? 0) >= (p.taskCount ?? 0);
                return (
                  <tr key={p.id} className="spd-row">
                    <td className="spd-td-name">
                      {/* 정렬은 이 래퍼가 한다 — td 자체를 flex 로 만들면 행 구분선에 단차가 생긴다. */}
                      <span className="spd-name-wrap">
                        <span className="spd-pdot" style={{ background: projectAccent(p) }} aria-hidden />
                        <button
                          type="button"
                          className="spd-pname"
                          onClick={() => navigate(`/task?team=${teamId}&project=${p.id}`)}
                        >
                          {p.name}
                        </button>
                      </span>
                    </td>
                    <td>
                      {/*
                        ✅ 2026-10-08 (저녁) — ★ 정본의 «두 상태»로 돌렸다(서버가 칸을 보낸다).
                          ⇒ ⚠ 타입은 `?:` 라 `undefined` 가 ★ 「될 수 있다」 — 그러면 여기서
                            ⭐ 「미참여」로 그려진다. ⇒ ⇒ ★ 그것이 «거짓»이 되지 않도록
                            ⇒ ⭐ «가드»가 ★ 「서버가 그 칸을 늘 보낸다」를 잠근다(머리말 ⓐ).
                          ⇒ ⛔ 즉 ★ 세째 상태를 «화면»에서 떼는 대신 ⇒ ⭐ «계약»에 두었다.
                      */}
                      <span className={`spd-role${p.myRole ? '' : ' spd-role--none'}`}>
                        {p.myRole
                          ? tProject((ROLE_LABEL[p.myRole] ?? 'project.space.role_member') as never)
                          : tProject('project.space.role_none')}
                      </span>
                    </td>
                    <td>
                      <span className="spd-progress">
                        <span className="spd-bar"><span className="spd-bar-fill" style={{ width: `${pct(p)}%` }} /></span>
                        <b>{pct(p)}%</b>
                      </span>
                    </td>
                    <td className="spd-dash">-</td>
                    <td>{p.dueDate ? p.dueDate.replace(/-/g, '.') : <span className="spd-dash">-</span>}</td>
                    <td>
                      <span className={`spd-status${done ? ' spd-status--done' : ''}`}>
                        <i aria-hidden />
                        {tProject(done ? 'project.space.status_done' : 'project.space.status_active')}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>

        {infoOpen && (
          <aside className="spd-info" aria-label={tProject('project.space.info')}>
            <h2>{tProject('project.space.info')}</h2>

            <div className="spd-owner">
              {owner ? (
                <>
                  <Avatar userId={Number(owner.userId) || 0} name={owner.name} src={owner.avatarUrl} size="sm" />
                  <span className="spd-owner-body">
                    <b>{owner.name}{owner.userId === myId ? ` · ${tProject('project.space.me')}` : ''}</b>
                    <small>{owner.email}</small>
                  </span>
                  <span className="spd-owner-role">{tProject('project.space.role_owner')}</span>
                </>
              ) : (
                <p className="spd-muted">{tProject('project.info.no_members')}</p>
              )}
            </div>

            <div className="spd-field">
              <span className="spd-label">{tProject('project.info.desc')}</span>
              <p className={team?.description ? 'spd-desc' : 'spd-desc spd-desc--empty'}>
                {team?.description || tProject('project.space.desc_placeholder')}
              </p>
            </div>

            <div className="spd-field">
              <span className="spd-label">{tProject('project.space.members', { n: String(members.length) })}</span>
              <span className="spd-avatars">
                {members.slice(0, 8).map((m) => (
                  <Avatar key={m.userId} userId={Number(m.userId) || 0} name={m.name} src={m.avatarUrl} size="xs" />
                ))}
                {members.length === 0 && <span className="spd-muted">{tProject('project.info.no_members')}</span>}
              </span>
            </div>

            <div className="spd-field">
              <span className="spd-label">{tProject('project.space.chart')}</span>
              <div className="spd-donut" style={{ ['--pct' as string]: `${donutPct}` }} role="img"
                aria-label={tProject('project.space.chart_aria', { done: String(donutDone), total: String(projects.length) })}>
                <b>{projects.length}</b>
                <small>{tProject('project.space.chart_unit')}</small>
              </div>
              <ul className="spd-legend">
                <li><i className="spd-legend-dot spd-legend-dot--active" aria-hidden />{tProject('project.space.status_active')} {donutActive}</li>
                <li><i className="spd-legend-dot spd-legend-dot--done" aria-hidden />{tProject('project.space.status_done')} {donutDone}</li>
              </ul>
            </div>
          </aside>
        )}
      </div>

      {creating && (
        <ProjectCreateSimpleModal
          teams={team ? [team] : []}
          initialTeamId={teamId}
          onClose={() => setCreating(false)}
          onCreated={() => { setCreating(false); void load(); }}
        />
      )}
    </div>
  );
}

function pct(p: TaskProjectDto): number {
  const total = p.taskCount ?? 0;
  return total > 0 ? Math.round(((p.doneTaskCount ?? 0) / total) * 100) : 0;
}

/**
 * 프로젝트 점 색 — ⭐ main 이 ★ 이미 적어 둔 규칙 그대로다(api/tasks.ts:37-38):
 *   「`color` 는 null 일 수 있다 — 그때는 종전처럼 id 해시 색(`stripColor`)으로 그린다」
 * ⇒ ⛔ 정본의 `projectColor` 를 베끼지 «않았다» — 색표를 ★ 두 벌로 만들면 ⭐ 조용히 갈라진다.
 *
 * ## ⭐ 2026-10-10 정정 — ★ 그 `projectColor` 가 ⇒ ⭐ 레포에 «생겼다»
 *
 * ```
 * ⇒ `pages/TaskPage/ProjectTopBar.tsx` ⇒ ★ export function projectColor(p) { return p.color ?? stripColor(p.id); }
 *    ⇒ 까닭 ⇒ ★ 정본 `pages/ProjectPage/SpaceDetailPage.tsx` 가 ⭐ 그것을 가져간다(이관)
 *    ⇒ ⇒ ✅ 위 ⛔ 의 까닭(「색표를 ★ 두 벌로 만들지 않는다」)에는 ⇒ ⭐ 걸리지 «않는다»
 *       ⇒ ⇒ ★ 그 함수는 ⭐ 표를 안 만들고 ⇒ 바로 `stripColor` 를 부른다(⇒ 2026-10-10 관제 확인)
 * ⇒ ⚠ 그래서 ★ 지금 ⇒ ⭐ 같은 뜻이 ★ «두 이름»으로 있다 ⇒ ⇒ projectAccent(여기) · projectColor(그쪽)
 * ```
 * ⏳ **만료** — ★ ㉤(라우터 전환)에서 ⇒ ⭐ 이 파일이 죽는 날 ⇒ ★ `projectAccent` 가 함께 사라진다
 *   ⇒ ⇒ ⭐ 그때 ★ 이름이 ⭐ «하나»가 된다. ⇒ ⇒ ⛔ 그 전에 ★ 한쪽을 지우지 말 것(도는 것이 둘이다).
 */
function projectAccent(p: TaskProjectDto): string {
  return p.color ?? stripColor(p.id);
}

/*
 * ⭐ 2026-10-08 (저녁) — ★ 여기 있던 것 ⭐ «둘»을 지웠다. 적어 두는 까닭:
 *   ⇒ ⛔ 「지웠다」만 적고 ★ 까닭을 안 적으면 ⇒ ⭐ 다음 사람이 ★ 다시 만든다.
 * ```
 * ⓐ myRoleOf(p)            ★ 좁은 캐스팅으로 `myRole` 을 읽던 함수
 *    ⇒ ✅ `api/tasks.ts` 의 `TaskProjectDto.myRole` 칸이 생겼으므로 ⇒ ⭐ `p.myRole` 로 충분하다
 * ⓑ SPACE_COLORS (8색) ＋ spaceColor(id)
 *    ⇒ ✅ 사용자 결정 ③ 「맞춥니다」 ⇒ ⭐ `stripColor` ★ 하나로 모았다 (머리말 ⓒ)
 *      ⇒ ⭐ 2026-10-11 정정 ⇒ ★ 그 표가 ⇒ ⭐ «정본 8색»이 됐다(사용자 「b」) — ⇒ ★ 여전히 ⭐ 한 벌
 *    ⇒ ⛔ ★ 되살리지 마십시오 — 되살리면 ⇒ ⭐ 같은 팀이 `/project/teams` 와 ★ 다른 색이 된다
 *      (잰 값: 두 표가 같은 색을 주는 비율 ★ 16.5% ⇒ ⭐ 84% 가 어긋난다)
 *    ⇒ ⭐ 가드가 ★ 「팀/프로젝트를 칠하는 색표가 ⭐ 한 벌」을 잰다 — ⚠ 그 «범위»를 보라:
 *      ⛔ 캘린더·간트·워크스페이스의 색표는 ★ «다른 것»을 칠한다 ⇒ 그 가드의 대상이 아니다.
 * ```
 */
